import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IProject, Projects } from '../../../_data/projects';

@Component({
  selector: 'app-portfolio-page',
  templateUrl: './portfolio-page.component.html',
  styleUrls: ['./portfolio-page.component.scss'],
})
export class PortfolioPageComponent implements OnInit, OnDestroy {
  // URL
  id: number;
  private sub: any;
  // Page data
  project: IProject;
  nextProject: IProject;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.sub = this.route.params.subscribe((params) => {
      this.showPage(params['id']);
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  showPage(id) {
    this.project = Projects.filter((p) => {
      return p.id === id;
    })[0];
    this.nextProject = Projects.filter((p) => {
      let f = this.project.featured + 1;
      if (f === Projects.length) {
        f = 0;
      }
      return p.featured === f;
    })[0];
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/portfolio/portfolio-page/portfolio-page.component.ts